import React, {Component} from 'react';
import {Chat} from '../components';
import {database, functions} from '../firebase/index'

class ChatTemplate extends Component {
    constructor(props) {
        super(props);

        this.pushInitData = (async () => {
            const pushAction = database.ref('answer').push({
                theme: "top",
                question: "1",
                answer: "",
            })
            this.state = {
                answers: [],
                id: pushAction.key,
            };
        })();
    }

    componentDidMount() {
        let msgs = this.props.messages.msgs;

        try {
            // Fetch initial question
            database.ref('answer').child(this.state.id).on('value', snapshot => {
                database.ref(snapshot.val().theme).child(snapshot.val().question).once('value', snapshot => {
                    let answers = [];
                    const value = snapshot.val();
                    const message = value.message;
                    const answer = value.answer;

                    msgs.push({
                        image: "https://firebasestorage.googleapis.com/v0/b/playground-chatbot-529d4.appspot.com/o/src%2Ffavicon.ico?alt=media&token=dd86864d-51ad-45d5-ba60-9f49b5225726",
                        isMyMessage: false,
                        text: message
                    });

                    for (const key of Object.keys(answer)) {
                        answers.push(answer[key])
                    }

                    this.setState({
                        msgs: msgs,
                        answers: answers
                    })
                });
            });
        } catch (e) {
            console.error(e)
        }
    }

    componentDidUpdate() {
        const scrollArea = document.getElementById("scroll-area");
        scrollArea.scrollTop = scrollArea.scrollHeight;
    }

    componentWillUnmount() {
        return database.ref('answer').child(this.props.messages.id).off()
    }

    render() {
        return (
            <div className="p-chat">
                <div className="p-chat__area" id="scroll-area">
                    {this.props.messages.msgs.map((m, i) => (
                        <Chat.AlignItemsList key={i} msgs={m} />
                    ))}
                </div>
                <div className="p-chat__area-answer">
                    <h3>回答を選んでみましょう！</h3>
                    <ul>
                        {this.state.answers.map((m, i) => (
                            <li>
                                <Chat.AnswerButton
                                    id={this.state.id}
                                    key={i}
                                    next={m.next}
                                    route={this.props.messages.route}
                                    text={m.text}
                                    theme={m.theme}
                                    onClick={this.props.actions.messages.select}/>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default ChatTemplate